import { render, staticRenderFns } from "./noticePage.vue?vue&type=template&id=381aefe2&scoped=true"
import script from "./noticePage.vue?vue&type=script&lang=js"
export * from "./noticePage.vue?vue&type=script&lang=js"
import style0 from "./noticePage.vue?vue&type=style&index=0&id=381aefe2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "381aefe2",
  null
  
)

export default component.exports